import React from 'react';
import PropTypes from 'prop-types';
import Button from '../base/Button/GlyphedButton';
import {PREVIOUS_GLYPH} from '../../const/Glyphicons';
import textTranslates from './translate.json';

const BackButton = (props) => {
    return(
        <Button
            disabled={props.isButtonDisabled}
            floated="left"
            glyph={PREVIOUS_GLYPH}
            id="backBtn"
            label={textTranslates.previousBtnLabel}
            onClick={props.onBackButtonClick}/>
    );
};

BackButton.propTypes = {
    isButtonDisabled: PropTypes.bool,
    onBackButtonClick: PropTypes.func
};

export default BackButton;


// WEBPACK FOOTER //
// ./src/components/Buttons/BackButton.js